import React, { useState, useEffect } from 'react';
import { Loader } from "@aws-amplify/ui-react";

const popupStyle = {
  position: 'fixed',
  background: 'white',
  border: '1px solid #ccc',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  padding: '16px',
  zIndex: 1000,
  transform: 'translate(-50%, -50%)',
  width: '280px'
};

const inputStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  marginBottom: '12px',
  fontSize: '14px'
};

const buttonStyle = {
  width: '100%',
  padding: '10px',
  border: 'none',
  borderRadius: '4px',
  background: '#1976d2', // A common primary color
  color: 'white',
  fontSize: '14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px'
};

const disabledButtonStyle = {
  ...buttonStyle,
  background: '#ccc',
  cursor: 'not-allowed'
};

const titleStyle = {
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '12px',
  color: '#333'
};


const MicrolotNamePopup = ({ isOpen, position, initialValue, onSave, onClose, title, isLoading }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (isOpen) {
      setName(initialValue || '');
    }
  }, [isOpen, initialValue]);

  const handleSave = (e) => {
    e.preventDefault();
    if (name.trim() && !isLoading) {
      onSave(name.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && !isLoading) {
      onClose();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, isLoading]);

  if (!isOpen || !position) {
    return null;
  }

  return (
    <div style={{ ...popupStyle, top: position.top, left: position.left }} onClick={(e) => e.stopPropagation()}>
      <button
        onClick={onClose}
        disabled={isLoading}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'transparent',
          border: 'none',
          fontSize: '18px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          color: '#888'
        }}
      >
        &times;
      </button>
      <form onSubmit={handleSave}>
        <div style={titleStyle}>{title || 'Nombre del microlote'}</div>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={inputStyle}
          placeholder="Escribe un nombre..."
          autoFocus
          disabled={isLoading}
        />
        <button type="submit" style={isLoading ? disabledButtonStyle : buttonStyle} disabled={isLoading}>
          {isLoading && <Loader />}
          {isLoading ? 'Guardando...' : 'Guardar'}
        </button>
      </form>
    </div>
  );
};

export default MicrolotNamePopup;
